import React, { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-4">
          <h1 className="text-3xl font-bold text-red-500 mb-4">¡Oops! Algo salió mal.</h1>
          <p className="text-gray-300 mb-6 text-center max-w-md">
            Ha ocurrido un error inesperado en la aplicación. Por favor, intenta recargar la página o volver al inicio.
          </p>
          <div className="flex gap-4">
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-[#e84137] text-white rounded-md font-semibold hover:opacity-90 transition"
            >
              Recargar Página
            </button>
            <button
              onClick={() => window.location.href = '/'}
              className="px-6 py-2 bg-transparent border border-white text-white rounded-md font-semibold hover:bg-white hover:text-black transition"
            >
              Volver al Inicio
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
